var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContentCopy = function SvgContentCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M704 42.667H192c-46.933 0-85.333 38.4-85.333 85.333v597.333H192V128h512zm128 170.666H362.667c-46.933 0-85.333 38.4-85.333 85.333v597.333c0 46.933 38.4 85.333 85.333 85.333H832c46.933 0 85.333-38.4 85.333-85.333V298.666c0-46.933-38.4-85.333-85.333-85.333M832 896H362.667V298.667H832z"
  })));
};
export default SvgContentCopy;